<template>
  <div id="cathea">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link class="navbar-brand" to="/" tag="a" exact>
        <img
          v-if="hasConnectionError"
          src="./assets/logo-ng.png"
          class="d-inline-block"
          alt="Cathea"
        >
        <img v-else src="./assets/logo.png" class="d-inline-block" alt="Cathea"> Cathea
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-01"
        aria-controls="navbar-01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbar-01">
        <ul class="navbar-nav mr-auto">
          <router-link class="nav-item" to="/" tag="li" active-class="active" exact>
            <a class="nav-link">Home</a>
          </router-link>
          <router-link
            v-if="isLoggedIn"
            class="nav-item"
            to="/user"
            tag="li"
            active-class="active"
            exact
          >
            <a class="nav-link">User</a>
          </router-link>
          <router-link class="nav-item" to="/about" tag="li" active-class="active" exact>
            <a class="nav-link">About</a>
          </router-link>
        </ul>
        <!-- User -->
        <form v-if="isLoggedIn" class="form-inline my-2" @submit.prevent="doLogout">
          <span class="navbar-text mx-2" v-text="user.name"></span>
          <button class="btn btn-danger mx-2" type="submit">Logout</button>
        </form>
        <span v-else>
          <router-link
            class="btn btn-primary mx-1"
            to="/login"
            tag="button"
            active-class="active"
            exact
          >Login</router-link>
          <router-link
            class="btn btn-success mx-1"
            to="/register"
            tag="button"
            active-class="active"
            exact
          >Join</router-link>
        </span>
      </div>
    </nav>
    <div class="container-fluid">
      <router-view/>
    </div>
  </div>
</template>

<script type="text/babel" language="javascript">
import 'bootstrap/dist/js/bootstrap.bundle.min'

import { mapGetters, createNamespacedHelpers } from 'vuex'
const { mapState: mapStateLogin, mapGetters: mapGettersLogin, mapActions: mapActionsLogin } = createNamespacedHelpers('user/login')
const { mapActions: mapActionsUser } = createNamespacedHelpers('user/session')

export default {
  data: () => ({}),
  computed: {
    ...mapStateLogin(['user']),
    ...mapGettersLogin(['isLoggedIn']),
    ...mapGetters(['isConnected', 'hasConnectionError'])
  },
  methods: {
    ...mapActionsLogin(['logout']),
    ...mapActionsUser(['unhook']),
    async doLogout () {
      const _self = this

      await _self.unhook()
      await _self.logout()

      _self.$router.push({ path: '/' })
    }
  }
}
</script>

<style type="text/css" lang="css">
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "./assets/skins/flatly.css";
</style>

<style type='text/css' lang='css'>
</style>
